<template>
  <Modal name="closeModal" :visible="mainStore.closeConfirmation">
    <template #title>Souhaitez-vous abandonner la création d'annonce&nbsp;?</template>
    <p>Si vous abandonnez la création d’annonce, les données de votre annonce seront perdues.</p>
    <template #actions>
      <a class="btn btn-block btn-primary" href="#continue" @click.prevent="abort">Oui, abandonner</a>
      <a class="btn btn-block btn-secondary" href="#abort" @click.prevent="resume">Non, annuler</a>
    </template>
  </Modal>
</template>

<script>
/* global ga */
import { mapStores } from 'pinia'
import { useMainStore } from '@/apps/fast/store'

import Modal from './Modal.vue'

export default {
  components: {
    Modal
  },
  data() {
    return {}
  },
  computed: {
    ...mapStores(useMainStore)
  },
  methods: {
    abort() {
      this.$root.close()
    },
    resume() {
      this.mainStore.closeConfirmation = false
    }
  }
}
</script>
